import { createSignal } from '@verclam/pulsar';

export type UserSidebarContext = {
	readonly userId: number | null;
};

/**
 * `null` closes the panel. A non-null context edits the user carried by `userId`; a `userId` of
 * `null` inside an open context invites one instead.
 */
const userSidebarSignal = createSignal<UserSidebarContext | null>(null);

export const openUserSidebar = (userId: number | null): void => {
	userSidebarSignal.value = { userId };
};

export const closeUserSidebar = (): void => {
	userSidebarSignal.value = null;
};

export default userSidebarSignal;
